import { jsx } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import { validateTidalLicense } from "../../base/index.js";
function Check(props) {
  return /* @__PURE__ */ jsx(
    CheckIcon,
    {
      "data-testid": "Check",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Check",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Check.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Check"
};
validateTidalLicense();
export {
  Check
};
//# sourceMappingURL=Check.js.map
